export class NotificationAdapter {
	error(_message?: string, _title?: string): unknown {
		throw new Error("You have to implement the method error.");
	}
	success(_message?: string, _title?: string, _options?: Record<string, unknown>): unknown {
		throw new Error("You have to implement the method success.");
	}
	info(_message?: string, _title?: string): unknown {
		throw new Error("You have to implement the method info.");
	}
	warning(_message?: string, _title?: string): unknown {
		throw new Error("You have to implement the method warning.");
	}
	clear(_clearErrorWarningToastsOnly?: boolean): void {
		throw new Error("You have to implement the method clear.");
	}
}
